
import { Component, Vue } from "vue-property-decorator";
import { lectureService } from "@/service/api/LectureService";
import { LectureProgressRateTableConfig } from "@/components/lecture/detail/model/LectureProgressRateTableConfig";

@Component
export default class LectureProgressRateByUser extends Vue {
  private isLoading = false;
  private lectureId = -1;

  private lectureProgressRateTableConfig = LectureProgressRateTableConfig;
  private lectureProgressRateByUserList: LectureProgressRateByUserData[] = [];

  public created(): void {
    this.lectureId = parseInt(this.$route.params.id);

    this.getLectureProgressRateByUser();
  }

  private getLectureProgressRateByUser(): void {
    this.isLoading = true;

    lectureService
      .retrieveLectureProgressRateByUser(this.lectureId)
      .subscribe(
        (
          lectureProgressRateByUserDataList: LectureProgressRateByUserData[]
        ) => {
          this.lectureProgressRateByUserList = lectureProgressRateByUserDataList;

          this.isLoading = false;
        }
      );
  }

  private checkWithdrawnUser(email: string): string {
    return email ? email : "탈퇴한 회원입니다.";
  }

  private formatInflearnRate(rate: number | string | undefined): string {
    if (rate === undefined || rate === null || rate === "") {
      return "0";
    }
    const num = typeof rate === "string" ? parseFloat(rate) : rate;
    return Number.isFinite(num) ? Number(num.toFixed(2)).toString() : "0";
  }

  private inventedRowKey(
    record: LectureProgressRateByUserData,
    index: number
  ): string {
    return record.user.id + "." + index;
  }
}
